import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';

const CanceledPurchase = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ minHeight: '80vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default', p: 3 }}>
      <Box sx={{ textAlign: 'center', bgcolor: 'background.paper', p: 4, borderRadius: 4, boxShadow: 4, maxWidth: 420 }}>
        <Typography variant="h4" color="error" fontWeight={700} gutterBottom>Purchase Canceled</Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>Your payment was not completed. If this was a mistake, you can try again at any time.</Typography>
        <Button variant="contained" color="primary" sx={{ mt: 2, borderRadius: 999 }} onClick={() => navigate('/products')}>
          Back to Shop
        </Button>
      </Box>
    </Box>
  );
};

export default CanceledPurchase; 